import { getCookie } from '@/utils/cookies';
import { api, auth } from './http';

export const getGridMeta = async (path, name) => {
    const response = await api(path, { name });
    return response;
};

export const getMenuMainLayoutList = async () => {
    try {
        const args = {
            app_id: +getCookie('app'),
        };
        const { result, data } = await auth('meta./main-menu/meta/get', args);
        return result ? data : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
        };
    }
};

export const getAppVersion = async () => {
    try {
        const { result, version } = await api('meta./meta/globset-version/get');
        if (result) {
            return {
                success: true,
                version,
            };
        }
    } catch (e) {
        return {
            success: false,
            error: e.message,
        };
    }
};

export const getAccessDenidedRoutes = async rights => {
    const listMetaRoutersResp = await auth('meta./meta/ui-routes-block-access/get', { rights });
    return listMetaRoutersResp;
};

export const getAppListByUserId = async () => {
    try {
        // todo после разделения функции в базе по получению приложений и департаментов тянуть метод getDepartList для получения департаментов
        const { result, items } = await auth('meta./user/app/list/get');
        return {
            result,
            items: items ? items : [],
        };
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '0377791b-0aec-411d-b899-9112ef439c24',
        };
    }
};

export const getAllApp = async () => {
    try {
        const { result, items } = await api('meta./app/list-all/get');
        return {
            result,
            items: items ? items : [],
        };
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '1548ee70-9705-4fb8-8dd9-678ac2f380b5',
        };
    }
};

export const getDepartList = async () => {
    try {
        const { result, items } = await api('meta./department/list/get');
        return { result, items: items ? items : [] };
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5e85c3c5-f38b-486f-b12e-305139614d1e',
        };
    }
};

export const getAppInfo = async appId => {
    try {
        const resp = await api('meta./meta-app/app-info/get', { id_app: appId });
        return resp;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'a305ddea-cb15-4b6a-bab5-51f6f006e22d',
        };
    }
};

export const getDataBaseVersion = async () => {
    try {
        const resp = await auth('meta./meta/database-version/get');
        return resp;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '795898dd-78d7-49e6-a26f-92d4151415e0',
        };
    }
};

export const getBillingPeriod = async args => {
    try {
        const { result, get_glob_ym } = await auth('meta./meta/glob-ym/get', args);
        return result ? get_glob_ym : null;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'b132bd5b-599b-4574-b271-0500fe5808f3',
        };
    }
};

export const getDataSource = async (url, args) => {
    const appId = +getCookie('app');
    try {
        //добавил спред
        const resp = await api(url, { ...args, appId });
        return resp;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'cd75a359-25e3-4ce5-8aaf-67acad9f1304',
        };
    }
};

export const commitDataChanges = async (url, changes, args) => {
    try {
        return await api(url, { ...changes, ...args });
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '20b9c8b7-7e83-470e-a0ce-d544892a9f93',
        };
    }
};
